import { call, put, select } from 'redux-saga/effects';
import API from "../../API";
import {loadReportsError, loadReportsSuccess} from "./reports-action-creators";


export default function* loadReports() {

  try {
    const result = yield call(API.loadReports);
    console.log(result, 'RESULT FROM LOAD REPORT REQUEST');
    yield put(loadReportsSuccess(result.data));
  } catch(error) {
    console.log(error, 'ERROR FROM LOAD REPORT REQUEST');
    yield put(loadReportsError("Something went wrong..."))
  }

}


// WEBPACK FOOTER //
// ./src/modules/reports/load-reports-saga.js